import { forwardRef } from 'react';

import cn from 'classnames';

import { Hashtag } from '@shared/assets';

import * as st from './styles.module.scss';

interface Props extends React.ButtonHTMLAttributes<HTMLButtonElement> {
	error: boolean;
	selected: number;
	isOpen: boolean;
}

export const ButtonTag = forwardRef<HTMLButtonElement, Props>(
	({ error, selected, isOpen, ...props }, ref) => {
		return (
			<button
				className={cn(st.button, selected > 0 && st.number, isOpen && st.open, error && st.error)}
				type="button"
				ref={ref}
				{...props}
			>
				<Hashtag />
				<span>Теги</span>
				<span>{selected > 0 && selected}</span>
			</button>
		);
	}
);
